import React from 'react';
export function Footer() {
  return <footer className="bg-gray-100 py-6 border-t border-gray-200" data-id="element-48">
      <div className="max-w-7xl mx-auto px-8 text-center" data-id="element-49">
        <p className="text-gray-600 text-sm" data-id="element-50">
          Paid for by Friends of Justin Strekal
        </p>
      </div>
    </footer>;
}